import React from "react"
import {
    Link as RouterLink,
    LinkProps as RouterLinkProps,
} from "react-router-dom"
import Link, { LinkProps } from "@material-ui/core/Link"

const ReactRouterLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(
    //@ts-ignore
    (props, ref) => <RouterLink innerRef={ref} {...props} />,
)

interface ILinkRouter extends LinkProps {
    link: string
}

export default function StyledLink(props: ILinkRouter) {
    const { link, children, underline, className, target } = props
    return (
        <Link
            to={link}
            component={ReactRouterLink}
            underline={underline ? underline : "always"}
            className={className}
            target={target}
        >
            {children}
        </Link>
    )
}
